import React, { useEffect, useState } from 'react';
import service from '../../../services/service';
import { getLocaleStorageItem } from '../../../utils/localStorageHelper';
import { card, draftId, method } from '../../../constants/payData';
import { CheckoutPage } from './PaymentComponent';
import { useLocation } from 'react-router';

const CreditCardComponent = () => {
  const location = useLocation();
  const payType = getLocaleStorageItem(method);
  const [clientToken, setClientToken] = useState('');

  useEffect(() => {
    if (payType === card) {
      getClientToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getClientToken = () => {
    const queryParams = location && new URLSearchParams(location.search);
    if (
      !queryParams.get('payment_intent') &&
      !queryParams.get('payment_intent_client_secret') &&
      !queryParams.get('redirect_status')
    ) {
      const data = {
        orderId: getLocaleStorageItem(draftId),
      };

      service
        .getClientPaymentToken(data)
        .then((value: any) => setClientToken(value.data.data))
        .catch((e: any) => console.log('ERROR'));
    }
  };

  return <>{clientToken && <CheckoutPage clientSecret={clientToken} />}</>;
};

export default CreditCardComponent;
